class FAQSection {
  constructor(container) {
    this.container = container;
    this.categoryButtons = [];
    this.faqItems = [];
    this.currentCategory = this.container
      .querySelector("[data-category]")
      .getAttribute("data-category");
    this.isDesktop = window.innerWidth > 990;
    this.categoryIndicator = null;
    this.init();
  }

  init() {
    this.setupElements();
    this.bindEvents();
    this.showCategory(this.currentCategory);
    this.setupCategoryIndicator();
  }

  setupElements() {
    this.isDesktop = window.innerWidth > 990;
    this.categoryButtons = this.container.querySelectorAll(
      ".faq-section__category-btn"
    );
    this.faqItems = this.container.querySelectorAll(".faq-section__faq-item");
    this.categoryIndicator = this.container.querySelector(
      ".faq-section__category-indicator"
    );
    this.faqQuestions = this.container.querySelectorAll(
      ".faq-section__faq-question"
    );
  }

  setupCategoryIndicator() {
    return;
  }

  updateCategoryIndicator(button) {
    return;
  }

  bindEvents() {
    this.categoryButtons.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        const category = button.getAttribute("data-category");
        this.switchCategory(category, button);
      });
    });
    this.faqQuestions.forEach((question) => {
      question.addEventListener("click", (e) => {
        e.preventDefault();
        this.toggleFAQ(question);
      });
    });
    let resizeTimeout;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        const wasDesktop = this.isDesktop;
        this.isDesktop = window.innerWidth > 990;
        if (wasDesktop !== this.isDesktop) {
          this.setupElements();
          this.showCategory(this.currentCategory);
          this.setupCategoryIndicator();
        }
      }, 150);
    });
    document.addEventListener("shopify:section:load", (event) => {
      if (event.target.contains(this.container)) {
        this.destroy();
        setTimeout(() => this.init(), 100);
      }
    });

    document.addEventListener("shopify:section:unload", (event) => {
      if (event.target.contains(this.container)) {
        this.destroy();
      }
    });
    document.addEventListener("shopify:block:select", (event) => {
      if (!this.container.contains(event.target)) return;
      const faqItem = event.target.closest(".faq-section__faq-item");
      if (faqItem) {
        const category = faqItem.getAttribute("data-category");
        if (category && category !== this.currentCategory) {
          this.switchCategory(category);
        }
        const question = faqItem.querySelector(".faq-section__faq-question");
        if (question) {
          this.openFAQ(question);
        }
      }
    });
  }

  switchCategory(category, buttonElement = null) {
    if (category === this.currentCategory) return;

    this.currentCategory = category;
    this.categoryButtons.forEach((btn) => {
      btn.classList.remove("faq-section__category-btn--active");
      if (btn.getAttribute("data-category") === category) {
        btn.classList.add("faq-section__category-btn--active");
        if (!this.isDesktop) {
          this.scrollCategoryIntoView(btn);
        }
      }
    });
    if (buttonElement && !this.isDesktop) {
      this.scrollCategoryIntoView(buttonElement);
    }
    this.showCategory(category);
  }

  scrollCategoryIntoView(button) {
    if (this.isDesktop) return;

    const scrollContainer = this.container.querySelector(
      ".faq-section__categories-scroll"
    );
    if (!scrollContainer) return;
    const buttonRect = button.getBoundingClientRect();
    const containerRect = scrollContainer.getBoundingClientRect();
    const scrollLeft =
      button.offsetLeft -
      scrollContainer.clientWidth / 2 +
      buttonRect.width / 2;

    scrollContainer.scrollTo({
      left: Math.max(0, scrollLeft),
      behavior: "smooth",
    });
  }

  showCategory(category) {
    this.faqItems.forEach((item) => {
      item.classList.remove("faq-section__faq-item--visible");
      const question = item.querySelector(".faq-section__faq-question");
      if (question) {
        this.closeFAQ(question, false);
      }
    });
    setTimeout(() => {
      let delay = 0;
      this.faqItems.forEach((item) => {
        const itemCategory = item.getAttribute("data-category");

        if (itemCategory === category) {
          setTimeout(() => {
            item.style.display = "block";
            item.offsetHeight;
            item.classList.add("faq-section__faq-item--visible");
          }, delay);
          delay += 50;
        } else {
          item.style.display = "none";
          item.classList.remove("faq-section__faq-item--visible");
        }
      });
    }, 100);
  }

  toggleFAQ(questionElement) {
    const isExpanded = questionElement.getAttribute("aria-expanded") === "true";

    if (isExpanded) {
      this.closeFAQ(questionElement);
    } else {
      this.openFAQ(questionElement);
    }
  }

  openFAQ(questionElement) {
    const faqItem = questionElement.closest(".faq-section__faq-item");
    const answer = faqItem.querySelector(".faq-section__faq-answer");

    if (!answer) return;
    this.faqItems.forEach((item) => {
      if (item !== faqItem) {
        const otherQuestion = item.querySelector(".faq-section__faq-question");
        if (otherQuestion) {
          this.closeFAQ(otherQuestion, false);
        }
      }
    });
    questionElement.setAttribute("aria-expanded", "true");
    faqItem.classList.add("faq-section__faq-item--expanded");
    const content = answer.querySelector(".faq-section__answer-content");
    if (content) {
      const contentHeight = content.scrollHeight;
      answer.style.maxHeight = `${contentHeight}px`;
    }
  }

  closeFAQ(questionElement, animate = true) {
    const faqItem = questionElement.closest(".faq-section__faq-item");
    const answer = faqItem.querySelector(".faq-section__faq-answer");

    if (!answer) return;

    questionElement.setAttribute("aria-expanded", "false");
    faqItem.classList.remove("faq-section__faq-item--expanded");

    if (animate) {
      answer.style.maxHeight = "0px";
    } else {
      answer.style.maxHeight = "0px";
    }
  }

  destroy() {}
}

document.addEventListener("DOMContentLoaded", function () {
  const sections = document.querySelectorAll(".faq-section");
  sections.forEach((section) => {
    new FAQSection(section);
  });
});
document.addEventListener("shopify:section:load", function (event) {
  const section = event.target.querySelector(".faq-section");
  if (section) {
    new FAQSection(section);
  }
});
